import React, { useEffect, useRef, useState } from "react";
import { Card } from "primereact/card";
import AppBreadcrumb from "../../components/CustomeBreadcrumb/AppBreadcrumb";
import { formatPageDate } from "../../appconfig/TemplateFieldSetting";
import { useNavigate } from "react-router-dom";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { InputNumber } from "primereact/inputnumber";
import {
  validateClientChargePaymentBy,
  validateClientProfileData,
} from "../../config/Validate";
import {
  CHANGE_DEFAULT_PAYMENT_CARD,
  GET_PROFILE_DATA_BY_ID,
  UPDATE_CLIENT_DATA,
} from "../../config/ApiConstant";
import {
  getAllDetails,
  postAllData,
  postSingleData,
} from "../../service/ProductService";
import { Toast } from "primereact/toast";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { RadioButton } from "primereact/radiobutton";
import { Badge } from "primereact/badge";
import moment from "moment";
import { SkeletonbodyTemplate, Skeletonitems } from "../../appconfig/Settings";
import UpdatePaymentMethod from "../../components/BankDetails/BankDetails";
import { Checkbox } from "primereact/checkbox";
import ViewSinNumber from "../../components/ViewSinNumber/ViewSinNumber";

const Profile: React.FC = () => {
  // get userData from local storage
  const rawUserData = localStorage.getItem("user_data");
  let userData: any = null;
  userData = rawUserData ? JSON.parse(rawUserData) : null;
  const userRole = userData?.roles?.role_name || "";
  const navigate = useNavigate();

  const toast = useRef<any>(null);

  // error state
  const [errors, setErrors] = useState<any>({});

  // loading
  const [pageLoading, setPageLoading] = useState<any>(true);

  // profile data obj
  const [profileData, setProfileData] = useState<any>(userData);

  //   add edit profile dialog
  const [editProfileDialog, setEditProfileDialog] = useState<boolean>(false);

  // state for business number to display static
  const [displayBusinessNumber, setDisplayBusinessNumber] = useState("");

  // btn submit loading
  const [submitLoading, setSubmitLoading] = useState<boolean>(false);

  // client payment obj
  const [clientPayment, setClientPayment] = useState<any>();

  // card details
  const [cardDetailsList, setCardDetailsList] = useState<any>([]);

  // profile details using api
  const [profileDetailsUpdate, setProfileDetailsUpdate] = useState<any>({
    client_charge_payment_by: "Self",
  });

  // stripe card detail form model
  const [showPaymentModal, setShowPaymentModal] = useState<boolean>(false);

  // states to change default payment card
  const [showDefaultModal, setShowDefaultModal] = useState<boolean>(false);
  const [selectedCard, setSelectedCard] = useState<any>(null);
  const [cardSubmitLoading, setCardSubmitLoading] = useState<boolean>(false);

  // redirect by role
  const redirectByRole = (role: string) => {
    switch (role) {
      case "Admin":
        return "/admin-dashboard";

      case "User":
        return "/user-dashboard";

      case "Client":
        return "/client-dashboard";

      case "Employee":
        return "/employee-dashboard";

      default:
        return "/dashboard";
    }
  };

  // setting business number for display purpose static
  useEffect(() => {
    if (profileData.bussiness_number) {
      const val = profileData.bussiness_number;
      const firstNine = val.slice(0, 9);
      const rest = val.slice(9);
      const displayVal = val.length > 9 ? `${firstNine} RP ${rest}` : val;
      setDisplayBusinessNumber(displayVal);
    }
  }, [profileData.bussiness_number]);

  // get profile data
  useEffect(() => {
    getProfileData();
  }, []);

  // get profile data
  const getProfileData = async () => {
    try {
      setPageLoading(true);
      const response = await getAllDetails(
        `${GET_PROFILE_DATA_BY_ID}/${userData?.id}`
      );

      if (response) {
        setCardDetailsList(response?.card_details);
        // set local storage with card detail added or not (flag)
        const payment_details_added = response?.payment_details_added;
        localStorage.setItem("payment_details_added", payment_details_added);
      }
    } catch (error: any) {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: error.response?.data?.message,
      });
    } finally {
      setPageLoading(false);
    }
  };

  // onchange
  const onInputChange = (e: any, name: string) => {
    let val = e?.target?.value ?? e?.value;

    // format postal code: add space after 3 characters
    if (name === "postal_code" && val) {
      // remove all spaces first
      val = val.replace(/\s+/g, "").toUpperCase();
      // insert space after 3 characters if length > 3
      if (val.length > 3) {
        val = val.slice(0, 3) + " " + val.slice(3);
      }
    }

    // format Business number
    if (name === "bussiness_number") {
      // remove spaces and RP
      const cleanVal = val.replace(/\s+/g, "").replace("RP", "");
      // const cleanVal = val;

      // create display version
      let displayVal = cleanVal;
      if (cleanVal.length > 9) {
        const firstNine = cleanVal.slice(0, 9);
        const rest = cleanVal.slice(9);
        displayVal = `${firstNine} RP ${rest}`;
      }

      // update what user sees in input
      setDisplayBusinessNumber(displayVal);

      // update your global state with clean (no RP)
      setProfileData({
        ...profileData,
        bussiness_number: cleanVal,
      });
      setErrors({ ...errors, [name]: "" });

      return;
    }

    setProfileData({ ...profileData, [name]: val });
    setErrors({ ...errors, [name]: "" });
  };

  // on input change for client charge payment by
  const onInputHandleChange = (e: any, name: string) => {
    let val = e?.target?.value ?? e?.value;

    setProfileDetailsUpdate({ ...profileDetailsUpdate, [name]: val });
    setErrors({ ...errors, [name]: "" });
  };

  // profile edit dialog
  const editDialog = () => {
    setEditProfileDialog(true);
    setProfileData(userData);
  };

  // hide profile dialog
  const hideEditDialog = () => {
    setEditProfileDialog(false);
    setErrors({});
  };

  // update api call of profile data for userRole === client
  const submitProfileData = async () => {
    try {
      const { isError, errors } = validateClientProfileData(profileData);

      setErrors(errors);
      if (isError) return;

      setSubmitLoading(true);
      const payload = {
        company_name: profileData.company_name,
        email: profileData.email,
        phone: profileData.phone,
        bussiness_number: profileData.bussiness_number,
        address: profileData.address,
        postal_code: profileData?.postal_code,
        type: "Client",
        edit: "profile",
      };

      const response = await postAllData(
        UPDATE_CLIENT_DATA + "/" + profileData.id,
        payload
      );

      if (response) {
        toast.current?.show({
          severity: "success",
          summary: "Success",
          detail: response.message,
        });
        hideEditDialog();

        // object to update local storage
        const updatedData = {
          ...userData,
          company_name: profileData.company_name,
          email: profileData.email,
          phone: profileData.phone,
          bussiness_number: profileData.bussiness_number,
          client_charge: profileData.client_charge,
          address: profileData.address,
          postal_code: profileData?.postal_code,
        };
        // update local storage
        localStorage.setItem("user_data", JSON.stringify(updatedData));
      }
    } catch (error: any) {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: error?.response?.data?.message,
      });
    } finally {
      setSubmitLoading(false);
    }
  };

  // submit client payment for user role === User
  const submitClientPaymentData = async () => {
    try {
      // const { isError, errors } = validateClientChargePaymentBy({
      //   client_charge_payment_by: clientPayment,
      // });

      const { isError, errors } =
        validateClientChargePaymentBy(profileDetailsUpdate);

      setErrors(errors);
      if (isError) return;

      setSubmitLoading(true);

      // payload
      const payload = {
        paymentStatus: profileDetailsUpdate?.client_charge_payment_by,
      };

      // api call
      const response = await postAllData(
        UPDATE_CLIENT_DATA + "/" + profileData.id,
        payload
      );

      if (response) {
        toast.current?.show({
          severity: "success",
          summary: "Success",
          detail: response.message,
        });
      }
    } catch (error: any) {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: error?.response?.data?.message,
      });
    } finally {
      setSubmitLoading(false);
    }
  };

  // api call to change default payment card
  const handleMakeDefault = async () => {
    try {
      setCardSubmitLoading(true);
      const response = await postSingleData(
        `${CHANGE_DEFAULT_PAYMENT_CARD}/${selectedCard?.id}`
      );
      if (response) {
        toast.current?.show({
          severity: "success",
          summary: "Success",
          detail: response.message,
        });
        setShowDefaultModal(false);
        getProfileData();
      }
    } catch (error: any) {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: error?.response?.data?.message,
      });
    } finally {
      setCardSubmitLoading(false);
    }
  };

  // card number template
  const cardNumberTemplate = (rowData: any) => {
    return <div className="">{`********${rowData?.last4}`}</div>;
  };

  // on default card change
  const onDefaultCheckboxClick = (rowData: any) => {
    if (rowData.is_default) return;

    setSelectedCard(rowData);
    setShowDefaultModal(true);
  };

  // default selected card template
  const defaultSelectedCard = (rowData: any) => {
    return (
      <>
        <Checkbox
          checked={rowData.is_default}
          onChange={() => onDefaultCheckboxClick(rowData)}
          className="mr-2"
        />

        {rowData.is_default && <Badge value="Default" severity="success" />}
      </>
    );
  };

  // month and year expire date
  const expiryTemplate = (rowData: any) => {
    const date = moment(
      `${rowData?.exp_year}-${rowData?.exp_month}-01`,
      "YYYY-M-D"
    );

    return <span>{date.format("MMM, YYYY")}</span>;
  };

  return (
    <>
      <AppBreadcrumb
        currentMenu="Profile"
        pageName="Profile"
        pageTitle={
          <>
            <div className="gotopage-button-header">
              <Button
                icon="pi pi-arrow-left"
                className="mr-2 common-p-gotopage-button"
                onClick={() => navigate(redirectByRole(userRole))}
              />
              <span className="span-text">Profile</span>
            </div>
          </>
        }
      />

      <Card
        footer={
          <>
            {userRole === "Client" && (
              <div className="flex align-items-end justify-content-end align-self-end align-content-end">
                <Button
                  label="Edit"
                  icon="pi pi-pencil"
                  onClick={() => editDialog()}
                />
              </div>
            )}
          </>
        }
        className="p-0 bg-white"
        style={
          userRole === "Client" || userRole === "User"
            ? {}
            : { height: "calc(100% - 52px)" }
        }
      >
        <Toast ref={toast} />

        <div className="grid">
          <div className="flex mb-3 col-12">
            <div className="">
              <label className="font-bold text-gray-700">
                {userData?.roles?.role_name === "Client"
                  ? "Company Name"
                  : "Name"}
                :
              </label>
              <div className="flex gap-2 align-items-center">
                <h2 className="mt-1 mb-1 text-xl font-semibold text-gray-900">
                  {userData?.first_name ?? ""} {userData?.last_name ?? ""}{" "}
                  {userData?.company_name ?? ""}
                </h2>
              </div>
            </div>
          </div>

          {/* Right: Details */}
          <div className="col-12 md:col-12">
            <div className="grid p-fluid">
              {!window.cn(userData?.email) && (
                <div className="mb-1 md:mb-3 col-12 sm:col-6 md:col-4 lg:col-3">
                  <label className="font-bold text-gray-700">Email:</label>
                  <div className="text-gray-900">{userData?.email || "-"}</div>
                </div>
              )}

              {!window.cn(userData?.phone) && (
                <div className="mb-1 md:mb-3 col-12 sm:col-6 md:col-4 lg:col-3">
                  <label className="font-bold text-gray-700">Phone:</label>
                  <div className="text-gray-900">{userData?.phone || "-"}</div>
                </div>
              )}

              {!window.cn(userData?.joining_date) && (
                <div className="mb-1 md:mb-3 col-12 sm:col-6 md:col-4 lg:col-3">
                  <label className="font-bold text-gray-700">
                    Joining Date:
                  </label>
                  <div className="text-gray-900">
                    {userData?.joining_date
                      ? formatPageDate(userData?.joining_date)
                      : "-"}
                  </div>
                </div>
              )}

              {!window.cn(userData?.date_of_birth) && (
                <div className="mb-1 md:mb-3 col-12 sm:col-6 md:col-4 lg:col-3">
                  <label className="font-bold text-gray-700">
                    Date Of Birth:
                  </label>
                  <div className="text-gray-900">
                    {userData?.date_of_birth
                      ? formatPageDate(userData?.date_of_birth)
                      : "-"}
                  </div>
                </div>
              )}

              {!window.cn(userData?.client_charge) && (
                <div className="mb-1 md:mb-3 col-12 sm:col-6 md:col-4 lg:col-3">
                  <label className="font-bold text-gray-700">
                    Client Payment:
                  </label>
                  <div className="text-gray-900">
                    {userData?.client_charge || "-"}
                  </div>
                </div>
              )}

              {!window.cn(userData?.bussiness_number) && (
                <div className="mb-1 md:mb-3 col-12 sm:col-6 md:col-4 lg:col-3">
                  <label style={{ fontWeight: "bold" }}>Business No:</label>
                  <div>
                    {userData?.bussiness_number?.slice(0, 9) +
                      " RP " +
                      userData?.bussiness_number?.slice(-4) || "-"}
                  </div>
                </div>
              )}

              {userData?.roles?.role_name === "Employee" && (
                <>
                  {!window.cn(userData?.vacation_hold) && (
                    <div className="mb-1 md:mb-3 col-12 sm:col-6 md:col-4 lg:col-3">
                      <label style={{ fontWeight: "bold" }}>
                        {" "}
                        Is Vacation Payout On Hold:
                      </label>
                      <div>
                        {userData?.vacation_hold === true ? "Yes" : "No"}
                      </div>
                    </div>
                  )}

                  {!window.cn(userData?.vaccation_payout) && (
                    <div className="mb-1 md:mb-3 col-12 sm:col-6 md:col-4 lg:col-3">
                      <label style={{ fontWeight: "bold" }}>
                        Vacation Payout:
                      </label>
                      <div>
                        {userData.vaccation_payout
                          ? `${userData.vaccation_payout}%`
                          : "-"}
                      </div>
                    </div>
                  )}

                  {!window.cn(userData?.supervisor) && (
                    <div className="mb-1 md:mb-3 col-12 sm:col-6 md:col-4 lg:col-3">
                      <label style={{ fontWeight: "bold" }}>Supervisor:</label>
                      <div>
                        {" "}
                        {userData?.user?.first_name} {userData?.user?.last_name}
                      </div>
                    </div>
                  )}

                  {!window.cn(userData?.ei_exempt) && (
                    <div className="mb-1 md:mb-3 col-12 sm:col-6 md:col-4 lg:col-3">
                      <label style={{ fontWeight: "bold" }}>
                        Is EI Exempt:
                      </label>
                      <div>{userData?.ei_exempt === true ? "Yes" : "No"}</div>
                    </div>
                  )}

                  {!window.cn(userData?.cpp_exempt) && (
                    <div className="mb-1 md:mb-3 col-12 sm:col-6 md:col-4 lg:col-3">
                      <label style={{ fontWeight: "bold" }}>
                        Is CPP Exempt:
                      </label>
                      <div>{userData?.cpp_exempt === true ? "Yes" : "No"}</div>
                    </div>
                  )}
                </>
              )}

              {!window.cn(userData?.wage) && (
                <div className="mb-1 md:mb-3 col-12 sm:col-6 md:col-4 lg:col-3">
                  <label style={{ fontWeight: "bold" }}>Wage:</label>
                  <div>{userData.wage ? `$${userData.wage}` : "-"}</div>
                </div>
              )}

              {!window.cn(userData?.tax_deduction) && (
                <div className="mb-1 md:mb-3 col-12 sm:col-6 md:col-4 lg:col-3">
                  <label style={{ fontWeight: "bold" }}>Tax Deduction:</label>
                  <div>
                    {userData.tax_deduction
                      ? `${userData.tax_deduction}%`
                      : "-"}
                  </div>
                </div>
              )}

              {!window.cn(userData?.sin_number) && (
                <div className="mb-1 md:mb-3 col-12 sm:col-6 md:col-4 lg:col-3">
                  <label style={{ fontWeight: "bold" }}>SIN No:</label>
                  <ViewSinNumber
                    label="SIN Number"
                    value={userData?.sin_number}
                  />
                </div>
              )}

              {!window.cn(userData?.pay_schema) && (
                <div className="mb-1 md:mb-3 col-12 sm:col-6 md:col-4 lg:col-3">
                  <label className="font-bold text-gray-700">Pay Scheme:</label>
                  <div className="text-gray-900">
                    {userData?.pay_schema || "-"}
                  </div>
                </div>
              )}

              {!window.cn(userData?.pay_schema) && (
                <div className="mb-1 md:mb-3 col-12 sm:col-6 md:col-4 lg:col-3">
                  <label className="font-bold text-gray-700">
                    Pay Cheque Day:
                  </label>
                  <div>
                    {" "}
                    {userData?.pay_schema === "Monthly" ||
                      userData?.pay_schema === "Semi Monthly"
                      ? "7"
                      : userData?.pay_schema === "Bi Weekly"
                        ? "Upcoming Friday"
                        : userData?.paycheck || "-"}
                  </div>
                </div>
              )}

              {!window.cn(userData?.address) && userRole === "Employee" ? (
                <div className="mb-1 md:mb-3 col-12 sm:col-6 md:col-4 lg:col-3">
                  <label className="font-bold text-gray-700">
                    Street Address:
                  </label>
                  <div className="text-gray-900">
                    {userData?.address || "-"}
                  </div>
                </div>
              ) : userRole !== "Admin" ? (
                <div className="mb-1 md:mb-3 col-12 sm:col-6 md:col-4 lg:col-3">
                  <label className="font-bold text-gray-700">Address:</label>
                  <div className="text-gray-900">
                    {userData?.address || "-"}
                  </div>
                </div>
              ) : null}

              {!window.cn(userData?.city) && (
                <div className="mb-1 md:mb-3 col-12 sm:col-6 md:col-4 lg:col-3">
                  <label className="font-bold text-gray-700">City:</label>
                  <div className="text-gray-900">{userData?.city || "-"}</div>
                </div>
              )}

              {!window.cn(userData?.province) && (
                <div className="mb-1 md:mb-3 col-12 sm:col-6 md:col-4 lg:col-3">
                  <label className="font-bold text-gray-700">Province:</label>
                  <div className="text-gray-900">
                    {userData?.province || "-"}
                  </div>
                </div>
              )}

              {!window.cn(userData?.postal_code) && (
                <div className="mb-1 md:mb-3 col-12 sm:col-6 md:col-4 lg:col-3">
                  <label className="font-bold text-gray-700">
                    Postal Code:
                  </label>
                  <div className="text-gray-900">
                    {userData?.postal_code || "-"}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </Card>
      {userRole === "User" && (
        <>
          {/* card details table */}
          <div className="grid mt-5">
            <div className="col-12 md:col-8">
              <Card className=" bg-white ">
                <div className="card-header mb-3 flex justify-content-between">
                  <h5 className="font-bold text-gray-700 mb-0">Card Details</h5>
                  <Button
                    label="Add Card"
                    icon="pi pi-plus"
                    className="common-primary-button"
                    onClick={() => setShowPaymentModal(true)}
                  />
                </div>
                {!pageLoading ? (
                  <DataTable
                    className="p-datatable-customers"
                    value={cardDetailsList}
                    dataKey="id"
                    emptyMessage="No Card Details Found"
                    rowHover
                  >
                    <Column
                      field="brand"
                      header="Brand"
                      style={{ minWidth: "14rem" }}
                    ></Column>
                    <Column
                      field="last4"
                      header="Card No"
                      style={{ minWidth: "10rem" }}
                      body={cardNumberTemplate}
                    ></Column>

                    <Column
                      header="Expiry"
                      body={expiryTemplate}
                      style={{ minWidth: "10rem" }}
                    />
                    <Column
                      field="is_default"
                      header="Default Card"
                      body={defaultSelectedCard}
                    ></Column>
                  </DataTable>
                ) : (
                  <DataTable value={Skeletonitems}>
                    <Column
                      field="brand"
                      header="Brand"
                      style={{ minWidth: "14rem" }}
                      body={SkeletonbodyTemplate}
                    />
                    <Column
                      field="last4"
                      header="Card No"
                      style={{ minWidth: "10rem" }}
                      body={SkeletonbodyTemplate}
                    />
                    <Column
                      header="Expiry"
                      style={{ minWidth: "10rem" }}
                      body={SkeletonbodyTemplate}
                    />
                    <Column
                      field="is_default"
                      header="Default Card"
                      body={SkeletonbodyTemplate}
                    />
                  </DataTable>
                )}
              </Card>
            </div>

            {/* client payment card */}
            <div className="col-12 md:col-4 ">
              <Card
                className="p-0 bg-white"
                footer={
                  <>
                    <div className="flex pt-2 align-items-center justify-content-end p-0">
                      <Button
                        label="Submit"
                        icon="pi pi-check"
                        className="common-primary-button"
                        disabled={true}
                        onClick={submitClientPaymentData}
                      />
                    </div>
                  </>
                }
              >
                <div className="card-header">
                  <h5 className="font-bold text-gray-700 mb-3">
                    Client Payment Paid By
                  </h5>
                  <div className="">
                    {/* client charge payment by */}
                    <div className="field col-12 mb-0 ">
                      <div className="flex gap-4 ">
                        <div className="flex align-items-center">
                          <RadioButton
                            inputId="client_charge_payment_by"
                            name="client_charge_payment_by"
                            value="Self"
                            onChange={(e) =>
                              onInputHandleChange(e, "client_charge_payment_by")
                            }
                            checked={
                              profileDetailsUpdate?.client_charge_payment_by ===
                              "Self"
                            }
                          />
                          <label htmlFor="Self" className="ml-2">
                            Self
                          </label>
                        </div>
                        <div className="flex align-items-center">
                          <RadioButton
                            inputId="client_charge_payment_by"
                            name="client_charge_payment_by"
                            value="Client"
                            disabled={true}
                            // onChange={(e: any) => setClientPayment(e.value)}
                            // checked={clientPayment === "Client"}
                            onChange={(e) =>
                              onInputHandleChange(e, "client_charge_payment_by")
                            }
                            checked={
                              profileDetailsUpdate?.client_charge_payment_by ===
                              "Client"
                            }
                          />
                          <label htmlFor="Client" className="ml-2">
                            Client
                          </label>
                        </div>
                      </div>
                      <small className="p-invalid-txt">
                        {errors["client_charge_payment_by"]}
                      </small>
                    </div>
                  </div>
                </div>
                <div></div>
              </Card>
            </div>
          </div>
        </>
      )}

      {/* Add/Edit payee Dialog */}
      <Dialog
        visible={editProfileDialog}
        className="mx-3 lg:mx-0"
        style={{ width: "800px" }}
        header={"Edit Profile"}
        draggable={false}
        modal
        footer={
          <div className="flex pt-2 align-items-center justify-content-end">
            <Button
              label="Cancel"
              icon="pi pi-times"
              className="mr-2 p-button-secondary"
              onClick={hideEditDialog}
            />
            <Button
              label="Submit"
              icon="pi pi-check"
              onClick={submitProfileData}
              className="common-primary-button"
              loading={submitLoading}
            />
          </div>
        }
        onHide={hideEditDialog}
      >
        <div className="grid p-fluid formgrid">
          {/* Company Name */}
          <div className="field col-12 md:col-6">
            <label htmlFor="company_name">Company Name *</label>
            <div className="input-effect-div">
              <InputText
                value={profileData.company_name || ""}
                name="company_name"
                autoComplete="off"
                placeholder="Enter Company Name"
                onChange={(e) => onInputChange(e, "company_name")}
                className={errors["company_name"] && "p-invalid"}
              />
              <span className="focus-bg"></span>
            </div>
            <small className="p-invalid-txt">{errors["company_name"]}</small>
          </div>

          {/* Email */}
          <div className="field col-12 md:col-6">
            <label htmlFor="email">Email *</label>
            <div className="input-effect-div">
              <InputText
                value={profileData.email || ""}
                name="email"
                autoComplete="off"
                placeholder="Enter Email"
                onChange={(e) => onInputChange(e, "email")}
                className={errors["email"] && "p-invalid"}
              />
              <span className="focus-bg"></span>
            </div>
            <small className="p-invalid-txt">{errors["email"]}</small>
          </div>
          {/* Phone */}
          <div className="field col-12 md:col-6">
            <label htmlFor="phone">Phone *</label>
            <div className="flex-1 input-effect-div p-inputgroup">
              <span className="font-bold p-inputgroup-addon">+1</span>
              <InputText
                value={profileData.phone || ""}
                name="phone"
                autoComplete="off"
                placeholder="Enter Phone Number"
                onChange={(e) => onInputChange(e, "phone")}
                className={errors["phone"] && "p-invalid"}
                keyfilter="pint"
                maxLength={10}
              />
              <span className="focus-bg"></span>
            </div>
            <small className="p-invalid-txt">{errors["phone"]}</small>
          </div>

          {/* Buisness Number */}
          <div className="field col-12 md:col-6">
            <label htmlFor="bussiness_number">Business No *</label>
            <div className="input-effect-div">
              <InputText
                value={displayBusinessNumber || ""}
                name="bussiness_number"
                autoComplete="off"
                placeholder="Enter Business Number"
                maxLength={17}
                keyfilter={"pint"}
                onChange={(e) => onInputChange(e, "bussiness_number")}
                className={errors["bussiness_number"] && "p-invalid"}
              />
              <span className="focus-bg"></span>
            </div>
            <small className="p-invalid-txt">
              {errors["bussiness_number"]}
            </small>
          </div>

          {/* Postal Code */}
          <div className="field col-12 md:col-6">
            <label htmlFor="postal_code">Postal Code *</label>
            <div className="input-effect-div">
              <InputText
                value={profileData.postal_code || ""}
                name="postal_code"
                placeholder="Enter Postal Code"
                autoComplete="off"
                onChange={(e) => onInputChange(e, "postal_code")}
                className={errors["postal_code"] && "p-invalid"}
              />
              <span className="focus-bg"></span>
            </div>
            <small className="p-invalid-txt">{errors["postal_code"]}</small>
          </div>

          {/* Address */}

          <div className="field col-12 md:col-6">
            <label htmlFor="address">Address *</label>
            <div className="input-effect-div">
              <InputTextarea
                rows={3}
                value={profileData.address || ""}
                name="address"
                autoComplete="off"
                placeholder="Enter Address"
                onChange={(e) => onInputChange(e, "address")}
                className={errors["address"] && "p-invalid"}
              />
              <span className="focus-bg"></span>
            </div>
            <small className="p-invalid-txt">{errors["address"]}</small>
          </div>
        </div>
      </Dialog>

      {/* dialog for stripe card detail form */}
      <Dialog
        header="Add Card Details"
        visible={showPaymentModal}
        onHide={() => setShowPaymentModal(false)}
        modal
        draggable={false}
        dismissableMask={true}
        style={{ width: "35rem" }}
        footer={<div></div>}
      >
        <UpdatePaymentMethod
          customerId={userData?.customer_id}
          onSuccess={() => setShowPaymentModal(false)}
          getApiCall={() => getProfileData()}
        />
      </Dialog>

      {/* dialog to change default payment card */}
      <Dialog
        header="Make Default Card"
        visible={showDefaultModal}
        style={{ width: "400px" }}
        onHide={() => setShowDefaultModal(false)}
        footer={
          <>
            <div className="flex justify-content-end gap-2">
              <Button
                label="Cancel"
                icon="pi pi-times"
                className="p-button-secondary"
                onClick={() => setShowDefaultModal(false)}
              />
              <Button
                label="Confirm"
                icon="pi pi-check"
                loading={cardSubmitLoading}
                className="common-primary-button"
                onClick={() => handleMakeDefault()}
              />
            </div>
          </>
        }
      >
        <h6>
          Are you sure you want to make this card as your default payment card?
        </h6>
      </Dialog>
    </>
  );
};

export default Profile;
